module.exports = __webpack_public_path__ + "media/images/logo-dark-b18f399dc4b815a3547299d52fe9e2c0.svg";